import clsx from 'clsx'

/* blocks */
import Link from '@/atoms/Link/Link'

/* assets */
import { ReactComponent as PepperLogo } from 'public/assets/icons/PepperLogo.svg'
import { ReactComponent as WhitePepperLogo } from 'public/assets/icons/PepperLogo_White.svg'

import { HeaderProps } from './Header'

function InfluencerDesktopHeader({
  className,
  primaryCta,
  secondaryCta,
  leaderLinkList,
  mode
}: HeaderProps): JSX.Element {
  return (
    <nav
      className={clsx(
        className,
        mode === 'dark' ? 'bg-blue-web-90 text-white' : 'bg-white text-gray-80',
        'sticky top-0 left-0 | h-18 | z-50'
      )}
    >
      <div className="max-header-width | flex items-center justify-between | mx-auto px-6 | h-full">
        <div className="flex items-center">
          <Link href="/" className="z-1 | pb-3" title="Homepage">
            {mode === 'dark' ? (
              <WhitePepperLogo style={{ width: 174, height: 33 }} />
            ) : (
              <PepperLogo
                style={{ width: 174, height: 33, color: '#1700e6' }}
              />
            )}
          </Link>
        </div>

        <div
          className={clsx(
            mode === 'dark' ? 'text-white' : 'text-blue-web-90',
            'flex gap-14'
          )}
        >
          {leaderLinkList.map(({ id, title, href }) => {
            return (
              <Link key={id} href={href}>
                {title}
              </Link>
            )
          })}
        </div>

        <div className="flex items-center">
          {secondaryCta ? (
            <Link
              href={secondaryCta.url}
              target="_blank"
              className={clsx(
                mode === 'dark'
                  ? null
                  : 'bg-white text-blue-web-50 border border-blue-web-50',
                'new-btn-secondary | max-h-8 | text-base font-medium | mr-3 px-4 py-1.5 | '
              )}
            >
              {secondaryCta.title}
            </Link>
          ) : null}
          {primaryCta ? (
            <Link
              href={primaryCta.url}
              target="_blank"
              className="new-btn-primary | max-h-8 | text-base font-medium | px-4 py-1.5"
            >
              {primaryCta.title}
            </Link>
          ) : null}
        </div>
      </div>
    </nav>
  )
}

export default InfluencerDesktopHeader
